// Affiliate destinations — the one list of outbound URLs that pay us.
//
// A link to one of these is a *paid* link in Google's terms and an *ad* in the
// CAP Code's, and both consequences follow from the destination alone. So they
// are applied by host rather than per-link: a post that drops a Healf or
// Unicity URL anywhere in its copy gets the right `rel` without anyone
// remembering to annotate the block. Same discipline as clinicDates.ts — add
// a new partner here and every renderer picks it up.
//
// Google treats an affiliate link that passes PageRank as a link scheme.
// `sponsored` is the accurate value; `nofollow` rides along because engines
// other than Google still only read that one.
//
// The rel does NOT discharge the CAP Code. That needs the *copy* beside the
// link to identify the content as advertising, which lives in blogs.json — see
// the disclosure sentences next to every link below.
export const AFFILIATE_HOSTS = [
  "healf.com",
  "ufeelgreat.com",
  "unicity.com", // covers shop2.unicity.com
];

export function isAffiliateUrl(href?: string | null): boolean {
  if (!href) return false;
  let host: string;
  try {
    // Relative hrefs are internal by definition; the base just keeps URL() from throwing.
    host = new URL(href, "https://cforganicwellness.com").hostname.toLowerCase();
  } catch {
    return false;
  }
  return AFFILIATE_HOSTS.some((h) => host === h || host.endsWith(`.${h}`));
}

// `rel` for an outbound link in blog copy. Non-affiliate externals keep the
// plain security rel they already had.
export function relForExternal(href?: string | null): string {
  return isAffiliateUrl(href) ? "sponsored nofollow noopener noreferrer" : "noopener noreferrer";
}
